import { create } from 'mobx-persist';
import * as stores from './';

class root {
  constructor(history) {
    // init
    const keys = Object.keys(stores);
    keys.forEach(key => {
      const _key = key.toLocaleLowerCase();
      const _fun = stores[key];
      this[_key] = new _fun(this, history);
    });

    // persist
    const { app, weibo, fb } = this;
    const hydrate = create(
      {
        // storage: localforage,
        // debounce: 100,
      }
    );

    hydrate('app', app).then(() => console.log('app hydrated'));
    hydrate('weibo', weibo).then(() => console.log('weibo hydrated'));
    hydrate('fb', fb).then(() => console.log('fb hydrated'));
  }
}

export default root;



// WEBPACK FOOTER //
// ./src/store/root.js